import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { ProtocolSection } from '../components/ProtocolSection';
import { WhoIsThisFor } from '../components/WhoIsThisFor';
import { PricingSection } from '../components/PricingSection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-slate-950 text-slate-200 font-sans selection:bg-indigo-500/30 selection:text-indigo-200" data-id="element-218">
      <Hero data-id="element-219" />
      <ProblemSection data-id="element-220" />
      <SolutionSection data-id="element-221" />
      <ProtocolSection data-id="element-222" />
      <WhoIsThisFor data-id="element-223" />
      <PricingSection data-id="element-224" />
      <Footer data-id="element-225" />
    </div>;
}